<template>
	<div class="vue-wrapper audit__log__list__wrapper">
			<Audit-Log-Filters
				:columns="Columns"
				:totals="$store.getters['auditLogList/getTotals']"
				:activeList="activeList"
				:callOptionMethod="$store.getters['auditLogList/getGrid'][this.activeList].statusLookup"
				v-on:update:filters="onFilterArgUpdate"
				v-on:submit:filters="onSubmitFilters"
				v-on:submit:csv="onSubmitCsv"
				:downloading="downloading"
				title="Audit Logs"
				:storeArgs="storeArgs"
				:storeModule="storeModule"
			/>

	<b-container class="audit-log-listing-margin laneclosure-view-container-mobile laneclosure-view-container laneclosure-list wide pl-0 pr-0 pt-0">
		<slot>
	<Spinner v-show="loading" />
		<audit-log-listing v-for="log in auditBatches" :key="log.id"
		:batchDetail="{user: log.userName,
						id: log.id,
						notes: log.batchNotes,
						time: moment(log.batchDate).format('MM/DD/YYYY HH:mm:ss'),
						auditTypeId: log.auditTypeId,
						organizationName: log.organizationName,
						organizationType: log.organizationType,
						lcrId: log.lcrId,
						organizationNamePath: log.organizationNamePath}"
		:logs="log.auditLog" :adminView="true" />
			</slot>
        <div class="paginateWrapper" v-show="!loading">
			<paginate
			:page-count="getPageCount"
			:page-range="3"
			:margin-pages="2"
			:click-handler="onPageClick"
			prev-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-left fa-w-10"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" class=""></path></svg>'
			next-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg>'
			:container-class="'page-ctrl'"
			:page-class="'page'"
			:next-class="'page-next'"
			:prev-class="'page-prev'"
			ref="auditLogPaginator"
			v-model="page"
			>
			</paginate>
		</div>
		<b-modal centered v-model="showErrorModal" type="info" @confirm="showErrorModal = false">
			<template slot="title">{{$t('errors.errorsOccurred')}}</template>
			<ul>
				<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'req'+requiredField">{{$t(requiredField)}}</li>
			</ul>
			<template slot="footer">
				<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
			</template>
		</b-modal>

	</b-container>
	</div>
</template>

<script>
import AuditLogFilters from "./../../../components/AuditLogFilters.vue"

import Spinner from "./../../../components/Spinner.vue"
import Organization from './../../../models/AuditLog.js'
import moment from 'moment'
import AuditLogListing from '../../../components/AuditLogListing.vue'
import ErrorHandler from '../../../utility/ErrorHandler';
import Format from "../../../utility/Format";
// import { link } from '../../../components/vue-wysiwyg/locales/english';

import store from '../../../store';


export default {
	docTitle: "Audit Logs - Lane Closures",

	components: {
		'Audit-Log-Filters': AuditLogFilters,
		Spinner,
		AuditLogListing,
	},
	mounted() {
		this.fetchData();
	},
	created() {

	},
	data() {
		return {
			Organization:Organization,
			auditBatches: null,
			activeList: 0,
			activeTabName:null,
			ascOrder: true,
			loading: true,
			page: 0,
			downloading: false,
			showErrorModal: false,
			modalRequiredFieldList: [],
			isButtonDisabled: false,
			storeModule:"auditLogList",
			storeArgs:"auditLogArgs",
		}
	},

	computed: {
		getPageCount() {
			let pageCount = 1;
			if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
				if (pagination) {
					if (pagination.count) {
						pageCount = Math.ceil(pagination.count / pagination.perPage);
						if (pageCount < 1) {
							pageCount = 1;
						}

					}
				}
			}
			return pageCount;
		},
		getPage() {
			let page = 1;
			if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
				if (pagination) {
					if (pagination.page >= 1) {
						return pagination.page;
					}
				}
			}
			return page;
		},
		Columns() {
			return this.$store.getters[this.storeModule+'/getGrid'][this.activeList].columns
		}
	},
	methods: {
		setTitle() {
		},
		friendlyDateFromNow(dt) {
			return Format.diffYMDHMSAgo(dt, new Date);
		},


		onFilterArgUpdate(queryArg) {
			// console.log(queryArg);
			this.$store.dispatch('auditLogList/updateParams', { page: 1 });
			this.$store.dispatch('auditLogList/updateParams', queryArg);
		},
		onSubmitFilters() {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery) {
				this.onFilterArgUpdate(argQuery)
			}
			this.$store.dispatch(this.storeModule+'/updateParams', { page: 1 } )

			this.fetchData()
		},
		forceArgUpdate() {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery) {
				this.onFilterArgUpdate(argQuery)
			}
			this.fetchData()
		},
		onPagePagination(value) {
			this.page = value
			this.$store.dispatch(this.storeModule+'/updatePagination', { page: value } )
		},
		fetchData() {
			document.getElementById('main').scrollTo(0,0)

			this.loading = true;
			// Vue.prototype.$http({
			// 	method: 'post',
			// 	url: `${this.$store.state.apiUrl}/audit-log/list/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
			// 	data: {}
			// }).then(res => {
			// 	this.auditBatches = res.data.logs;
			// 	this.loading = false;
			// });
			this.$store.dispatch('auditLogList/load', this.$store.getters['auditLogList/getParams'])
				.then(() => {
					this.auditBatches = [];
					let records = this.$store.getters['auditLogList/getRecords'];

					if (records) {
						records.forEach(item =>{
							this.auditBatches.push(item);
						});
					}

					this.loading = false;
				})
				.catch(error => console.log('error', error)); // eslint-disable-line
		},
		onPageClick(value) {
			this.page = value
			this.$store.dispatch('auditLogList/updateParams', { page: value } )
			this.fetchData()
			// updateParams({ commit }, params = Object()) {e
			// this.$store.dispatch('userList/updatePagination', { page: value } )
		},

		onSubmitCsv() {
			this.downloading = true;
			var filter = Object.assign({}, this.$store.getters['auditLogList/getParams']);
			this.fetchData();
			filter.perPage = 0;
			this.$store.dispatch("auditLogList/loadCsv", filter)
				.then(res => {
					const blob = new Blob([res.data], { type: 'text/csv' });
					const a = document.createElement("a");
					a.href = URL.createObjectURL(blob);
					a.download = `Audit Log ${moment().format("MM/DD/YYYY HH:mm:ss")}.csv`;
					a.click();
					URL.revokeObjectURL(a.href);
					this.downloading = false;
				})
				.catch(error => {
					if (error) {
						if (error.response) {
							if (!ErrorHandler.HasLoginErrorCode(error)) {
								// this.laneClosureRequest.SetErrors(error.response.data);
								this.showErrors(error.response.data.fields);
							} else {
								ErrorHandler.RedirectToLogin();
							}
						}
					}
					this.downloading = false;
				});

		},

		showErrors(errors) {
			this.submissionStatus = 'submission-error';
			this.modalRequiredFieldList = [];
			for (let field in errors) {
				this.modalRequiredFieldList.push(errors[field]);
			}
			this.showErrorModal = true;
		},
		modalRequiredFieldClose() {
			this.showErrorModal = false;
		},
	},
	beforeRouteEnter(to, from, next) {
		if (store.getters.userHasRole('internal_admin_requests') || store.getters.userHasRole('system_admin') || store.getters.userHasRole('internal_admin_reports')) {
			next();
		}
		else {
			next('/');
		}
	},

}
</script>
